((app) => {
    //
    // Md-dialog's "this" refers to the window instead of the an
    // isolated scope. So we'll set $ctrl to an empty object instead 
    // to keep the template naming convention intact.
    //
    app.controller("mapCarrierCtrl", ["$window", "$scope", "$mdDialog", "carrierMappingApi", "carrier", "mappedCarriers",
        ($window, $scope, $mdDialog, carrierMappingApi, carrier, mappedCarriers) => {
            let $ctrl = {};
            $scope.$ctrl = $ctrl;
            $ctrl.carrier = carrier;
            $ctrl.mappedCarriers = mappedCarriers;
            $ctrl.ui = { saving: false };

            $ctrl.close = (updates) => {
                $mdDialog.hide(updates);
            };

            $ctrl.isLinking = (linking) => {
                $ctrl.linking = linking;
            };

            $ctrl.save = () => {
                $ctrl.ui.saving = true;
                if (!$ctrl.linking && $ctrl.carrier.UnmappedCarrierId) {
                    _createMapping($ctrl.carrier);
                }
                else if (!$ctrl.linking && $ctrl.carrier.MappedCarrierId) {
                    _updateMappedName($ctrl.carrier);
                } else {
                    _linkMapping($ctrl.carrier, $ctrl.selectedLink);
                }
            };

            async function _createMapping(carrier) {
                let mapped = await carrierMappingApi.createCarrierMap(carrier);
                carrierMappingApi.mapCarrier(carrier, { MappedCarrierId: mapped.AggregateId })
                .then((response) => {
                    $ctrl.close(carrier);
                });  
            }

            function _updateMappedName(carrier) {
                carrierMappingApi.updateMappedName(carrier)
                    .then((response) => {
                        $ctrl.close(carrier);
                    });
            }

            function _linkMapping(carrier, link) {
                carrierMappingApi.mapCarrier(carrier, link)
                .then((response) => {
                   $ctrl.close(carrier);
                });
            }
        }]);
})(window.app);
